// extracted by mini-css-extract-plugin
export default {"formBanner":"styles_formBanner__J8hzq"};